import store from '@/store'
import { lazyLoad } from '../../index'

export default {
  path: 'productTypes',
  component: lazyLoad('Admin/Data/ProductTypes'),
}
